// ONLY RUN ON SHAMPOO QUIZ PAGE (SAFE CHECK)
const shampooPath = window.location.pathname.toLowerCase();
const onShampooQuizPage =
  shampooPath.includes("shampoo-quiz") || shampooPath.includes("shampooquiz");

if (onShampooQuizPage) {
  console.log("Shampoo Quiz JS loaded ✔");

  window.submitShampooQuiz = function () {
    console.log("submitShampooQuiz triggered");

    const hair = document.querySelector("input[name='hairType']:checked")?.value;
    const scalp = document.querySelector("input[name='scalp']:checked")?.value;
    const oilQuick = document.querySelector("input[name='oilQuick']:checked")?.value;
    const goal = document.querySelector("input[name='goal']:checked")?.value;
    const eo = document.querySelector("input[name='eoSensitive']:checked")?.value;
    const barOpen = document.querySelector("input[name='barOpen']:checked")?.value;
    const freq = document.querySelector("input[name='frequency']:checked")?.value;
    const swim = document.querySelector("input[name='swim']:checked")?.value;

    if (!hair || !scalp || !oilQuick || !goal || !eo || !barOpen || !freq || !swim) {
      alert("Please answer all questions.");
      return;
    }

    let result = "";

    // PRIORITY CONDITIONS
    if (eo === "yes") result = "unscented-bar";
    else if (swim === "yes") result = "swim-bar";
    else {
      const needsClarifying =
        scalp === "oily" ||
        scalp === "flaky" ||
        oilQuick === "yes" ||
        goal === "clarifying";

      const needsMoisture =
        scalp === "dry" ||
        goal === "moisture";

      if (needsClarifying) {
        result = barOpen === "yes" ? "clarifying-bar" : "clarifying-liquid";
      } else if (needsMoisture) {
        result = barOpen === "yes" ? "restorative-bar" : "restorative-liquid";
      } else if (barOpen === "yes" && goal === "gentle") {
        result = "lavender-bar";
      } else {
        result = "daily-liquid";
      }
    }

    console.log("Shampoo quiz result:", result);
    displayShampooResult(result);
  };

  // PRODUCT DATA
  const shampooProducts = {
    "clarifying-bar": {
      name: "Clarifying Shampoo Bar",
      img: "https://www.bella-hue.com/cdn/shop/files/Clarifying_Shampoo_sulfate_free.png?v=1738449475&width=700",
      url: "https://www.bella-hue.com/products/shampoo-bar-clarifying-oily-itchy-thinning",
      desc: "A solid clarifying cleanse that lifts buildup, excess oil, and minerals without stripping the scalp."
    },
    "clarifying-liquid": {
      name: "Clarifying Shampoo",
      img: "https://www.bella-hue.com/cdn/shop/files/Clarifying_Shampoo_sulfate_free.png?v=1738449475&width=700",
      url: "https://www.bella-hue.com/products/new-clarifying-shampoo-conditioner-1",
      desc: "A sulfate-free deep cleanse that removes buildup, dry shampoo, and hard water minerals."
    },
    "restorative-bar": {
      name: "Restorative Shampoo Bar",
      img: "https://www.bella-hue.com/cdn/shop/files/restorative_shampoo_sulfate_free.png?v=1738450926&width=700",
      url: "https://www.bella-hue.com/products/shampoo-bars",
      desc: "A nourishing bar that softens, hydrates, and restores fragile or color-treated hair."
    },
    "restorative-liquid": {
      name: "Restorative Shampoo",
      img: "https://www.bella-hue.com/cdn/shop/files/restorative_shampoo_sulfate_free.png?v=1738450926&width=700",
      url: "https://www.bella-hue.com/products/new-shampoo",
      desc: "A creamy, replenishing wash that boosts moisture and shine without weighing hair down."
    },
    "lavender-bar": {
      name: "Lavender Shampoo Bar",
      img: "https://www.bella-hue.com/cdn/shop/files/Restorative_shampoo_bar__sulfate_free_color_safe.png?v=1755873187&width=2048",
      url: "https://www.bella-hue.com/products/shampoo-bar-lavender-soothing-kids",
      desc: "A calming, gentle cleanse made for sensitive scalps, kids, and anyone wanting a mild shampoo."
    },
    "unscented-bar": {
      name: "Unscented Shampoo Bar",
      img: "https://www.bella-hue.com/cdn/shop/files/Unscented_shampoo_bar.png?v=1755798102&width=700",
      url: "https://www.bella-hue.com/products/shampoo-bar-unscented-sensitive-scalp-no-essential-oils",
      desc: "A fragrance-free bar designed for ultra-sensitive scalps and babies."
    },
    "swim-bar": {
      name: "Swim Repair Shampoo Bar",
      img: "https://www.bella-hue.com/cdn/shop/files/Swim_repair_shampoo_bar.png?v=1755794866&width=700",
      url: "https://www.bella-hue.com/products/swim-shampoo-bar",
      desc: "Removes chlorine and hard-water minerals while restoring softness after swimming."
    },
    "daily-liquid": {
      name: "Daily Shampoo",
      img: "https://www.bella-hue.com/cdn/shop/files/Daily_Shampoo_sulfate_free.png?v=1738449663&width=700",
      url: "https://www.bella-hue.com/products/daily-shampoo",
      desc: "A lightweight, sulfate-free daily cleanser that leaves hair fresh, soft, and balanced."
    }
  };

  // DISPLAY RESULT
  function displayShampooResult(key) {
    const product = shampooProducts[key];
    const box = document.getElementById("shampooResult");

    if (!box) {
      console.error("Result box #shampooResult not found.");
      return;
    }

    box.innerHTML = `
      <div style="text-align:center;">
        <img src="${product.img}" 
             alt="${product.name}" 
             style="width:100%; max-width:600px; border-radius:12px; margin-bottom:20px;">
        <h2>${product.name}</h2>
        <p>${product.desc}</p>
        <a href="${product.url}" class="button" style="margin-top:15px;">Shop Now</a>
      </div>
    `;

    box.style.display = "block";

    const restartBtn = document.getElementById("restartShampooQuizBtn");
    if (restartBtn) restartBtn.style.display = "block";

    // ⭐ AUTO SCROLL TO RESULT ⭐
    setTimeout(() => {
      box.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  }

  // IMPACT-SAFE CLICK LISTENER
  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "shampooSubmitBtn") {
      e.preventDefault();
      console.log("shampooSubmitBtn clicked ✔");
      submitShampooQuiz();
    }
  });

  // EXTRA SAFETY: FORM SUBMIT CATCH
  document.addEventListener("submit", function (e) {
    if (e.target && e.target.id === "shampooQuizForm") {
      e.preventDefault();
      submitShampooQuiz();
    }
  });

} // END PAGE CHECK